import Api from "./Api";
export default {
  getAgentsGrid(companyId) {
    return Api().get(`/agents/${companyId}`);
  },
  getAgentsHaveStores(companyId) {
    return Api().get(`/agents/${companyId}/sites`);
  },
  getAgentsSimple(companyId) {
    return Api().get(`/agents-simple/${companyId}`);
  },
  getAgentTypes() {
    return Api().get(`/agent-types`);
  },
  addAgent(payload) {
    return Api().post(`/agents`, payload);
  },
  duplicateAgent(payload) {
    return Api().post(`/agents/duplicate`, payload);
  },
  editAgent(payload) {
    return Api().put(`/agent/${payload.id}`, payload);
  },
  getAgentById(payload) {
    return Api().get(`/agent/${payload.companyId}/${payload.id}`, payload);
  },
  deleteAgent(payload) {
    return Api().delete(`/agent/${payload.companyId}/${payload.id}`);
  },
  runAgentTest(payload) {
    return Api().post(
      `/agent/${payload.companyId}/${payload.agentId}/test-scenario`,
      payload,
    );
  },
  getDefaultCompanyPrompt(companyId) {
    return Api().get(`/default-prompt/${companyId}`);
  },
  getPromptHistory(payload) {
    return Api().get(
      `/prompt-histories/${payload.companyId}/${payload.agentId}`,
    );
  },
  assignPrompt(payload) {
    return Api().post(`/assign-prompt`, payload);
  },
  getAllAgentsInstructionsGrid(companyId) {
    return Api().get(
      `proxy/ai/company/${companyId}/prompts_with_names`,
    );
  },
  addAgentInstructions(payload) {
    return Api().post(
      `proxy/ai/company/${payload.companyId}/prompts`,
      payload.data,
    );
  },
  editAgentInstructions(payload) {
    return Api().put(
      `proxy/ai/company/${payload.companyId}/prompts/${payload.id}`,
      payload.data,
    );
  },
  getAgentInstructionsById(payload) {
    return Api().get(
      `proxy/ai/company/${payload.companyId}/prompts_with_names/${payload.id}`,
    );
  },
  deleteAgentInstructions(payload) {
    return Api().delete(
      `proxy/ai/company/${payload.companyId}/prompts/${payload.id}`,
    );
  },
  previewRecommendation(payload) {
    return Api().post(
      `/integrations/${payload.companyId}/${payload.integrationId}/recommendations/preview`,
      payload.data,
    );
  },
  getRecommendationStatus(payload) {
    return Api().get(
      `/integrations/${payload.companyId}/${payload.integrationId}/recommendations/${payload.instructionId}`,
      { params: { site_id: payload.siteId } },
    );
  },
  activateRecommendation(payload) {
    return Api().post(
      `/integrations/${payload.companyId}/${payload.integrationId}/recommendations/${payload.instructionId}/activate`,
      payload.data,
    );
  },
  retryRecommendation(payload) {
    return Api().post(
      `/integrations/${payload.companyId}/${payload.integrationId}/recommendations/${payload.instructionId}/retry`,
      payload.data,
    );
  },
  getProductsBySearch(payload) {
    return Api().get(
      `proxy/ai/company/${payload.companyId}/products/search/similarity_with_trigram`,
      { params: payload.params },
    );
  },
  getCategoriesBySearch(payload) {
    return Api().get(
      `proxy/ai/company/${payload.companyId}/categories/search/similarity_with_trigram`,
      { params: payload.params },
    );
  },
  getAgentVoices() {
    return Api().get(`proxy/ai/voices`);
  },
  getAvatars() {
    return Api().get(`proxy/ai/avatars`);
  },
  getLlmModels() {
    return Api().get(`proxy/ai/llm_models`);
  },
  getSttModels() {
    return Api().get(`proxy/ai/stt_models`);
  },
  getAgentVoiceById(payload) {
    return Api().get(`proxy/ai/voices/${payload.voiceId}/sample`, {
      responseType: "blob",
    });
  },
  fetchDocumentsByAgent(companyId, agentId) {
    return Api().get(`/documents/${companyId}/${agentId}`);
  },
  deleteDocumentByAgent(companyId, fileId) {
    return Api().delete(`/document/${companyId}/${fileId}`);
  },
  getAgentImages(companyId, agentId) {
    return Api().get(`/agent-images/${companyId}/${agentId}`);
  },
  deleteAgentImage(companyId, agentId, imageId) {
    return Api().delete(`/agent-images/${companyId}/${agentId}/${imageId}`);
  },
};
